import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseAgentTypeaheadService } from './';

@Injectable()
export class AgentNameTypeaheadService extends BaseAgentTypeaheadService {
    constructor(http: Http) {
        super(http);
    }

    public getSearchType(): string {
        return this.agentNameSearch;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/services/agent-name-typeahead.service.ts